import { Http, History } from './../helpers'
import { BehaviorSubject } from 'rxjs'

const TOKEN_KEY = 'token'
const USER_KEY = 'user'

const currentUserSubject = new BehaviorSubject(
  localStorage.getItem(USER_KEY) || null,
)
const currentTokenSubject = new BehaviorSubject(
  localStorage.getItem(TOKEN_KEY) || null,
)

export const AuthService = {
  login,
  logout,
  getToken,
  getUser,
  isLoggedIn,
  clearToken,
}

function login(params) {
  return Http.post('/auth/login', {
    username: params.username,
    password: params.password,
  }).then((rs) => {
    if (rs && rs.data) {
      const TOKEN = rs.data['data']['token'] ? rs.data['data']['token'] : null
      const USER = JSON.stringify(rs.data['data']['user'])
      currentTokenSubject.next(TOKEN)
      currentUserSubject.next(USER)
      localStorage.setItem(TOKEN_KEY, TOKEN)
      localStorage.setItem(USER_KEY, USER)
    }
  })
  // .catch((err) => err)
}

function clearToken() {
  currentTokenSubject.next(null)
  currentUserSubject.next(null)
  localStorage.removeItem(TOKEN_KEY)
  localStorage.removeItem(USER_KEY)
}

function logout() {
  currentTokenSubject.next(null)
  currentUserSubject.next(null)
  localStorage.removeItem(TOKEN_KEY)
  localStorage.removeItem(USER_KEY)
  Http.post('/auth/logout').then(() => {})
}

function getToken() {
  return currentTokenSubject.value
}

function isLoggedIn() {
  return AuthService.getToken() ? true : false
}

function getUser() {
  const user = currentUserSubject.value
  if (user) {
    return JSON.parse(user)
  }
  return
}
